import { httpLink } from './links/httpLink';
import { errorLink } from '../../../../shared/lib/apollo/links/errorLink';
import { logoutLink } from './links/logoutLink';
import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { authLink } from './links/authLink';

// ! Never change this order if you don't want to face any unexpected errors
// * Reason: Response links execute in reverse order :-)

export const client = new ApolloClient({
  cache: new InMemoryCache(),
  connectToDevTools: true,
  link: from([logoutLink, errorLink, authLink, httpLink])
});
